export default "__VITE_ASSET__1S3XI1aj__"